import { render, staticRenderFns } from "./DataMapChart.vue?vue&type=template&id=6a40de4c&scoped=true"
import script from "./DataMapChart.vue?vue&type=script&lang=js"
export * from "./DataMapChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40de4c",
  null
  
)

export default component.exports